/**
 * 设置页面标题。
 *
 * iOS 微信内置浏览器只在页面首次加载时读一次 title, 之后改 document.title
 * 导航栏不会跟着变。这里用业界通用的 iframe 骗术: 加载一个同源小资源触发
 * 微信重新读取标题。安卓微信和普通浏览器不需要这一步。
 *
 * @param {string} title 页面标题
 */
export default function setDocumentTitle(title) {
  if (!title || document.title === title) {
    return
  }

  document.title = title

  const ua = window.navigator.userAgent
  if (!/iPhone|iPad|iPod/i.test(ua) || !/MicroMessenger/i.test(ua)) {
    return
  }

  const iframe = document.createElement('iframe')
  iframe.src = '/favicon.ico'
  iframe.style.display = 'none'
  iframe.onload = function() {
    setTimeout(function() {
      if (iframe.parentNode) {
        iframe.parentNode.removeChild(iframe)
      }
    }, 9)
  }
  document.body.appendChild(iframe)
}
